export default __webpack_public_path__ + "static/media/logo.f0796fb6.png";